import React from 'react';
/* eslint-disable  import/no-cycle -- need */
import findElement from './ElementFinder';

export const constructChildStructure = (elementsJson, props, callerId) => {
  // should we create a accordio check here as well?
  const checkProperty = (elm, prop) => {
    if (prop in elm) return true;
    return false;
  };

  const checkFieldType = (elem, prop) => {
    if (elem.fieldIndicator && elem.fieldType) {
      return (
        <div
          className={elem.cssProperties.style}
          key={elem.fieldId}
          style={elem.cssProperties.bgStyleObj ? elem.cssProperties.bgStyleObj : {}}
        >
          {findElement(elem, prop)}
        </div>
      );
    }
    if (elem.fieldIndicator !== false) {
      return (
        <div
          className={elem.cssProperties.style}
          key={elem.fieldId}
          style={elem.cssProperties.bgStyleObj ? elem.cssProperties.bgStyleObj : {}}
        >
          {elem.childElements && elem.childElements.map(
            (childProps) => (childProps.fieldIndicator
              && childProps.fieldType
              ? findElement(childProps, props)
              : checkFieldType(childProps, props)
            )
          )}
        </div>
      );
    }
    return null;
  };

  /* eslint-enable  import/no-cycle -- need */
  /* eslint-disable react/no-array-index-key -- need it temporarly */
  return elementsJson.map((element, rowIndex) => (element
    && checkProperty(element, 'childElements')
    && element.childElements.length < 2
    ? element.childElements.map(
      (childProps) => childProps.fieldIndicator && (
        <div
          className={element.cssProperties.style}
          key={`${callerId}-${rowIndex}`}
          style={element.cssProperties.bgStyleObj ? element.cssProperties.bgStyleObj : {}}
        >
          {findElement(childProps, props)}
        </div>
      )
    )
    : (
      <div
        className={element.cssProperties.style}
        key={`${callerId}-${rowIndex}`}
        style={element.cssProperties.bgStyleObj ? element.cssProperties.bgStyleObj : {}}
      >
        {element.childElements.map(
          (elem) => elem.fieldIndicator && (
            <div className={elem.cssProperties.style} key={elem.fieldId}>
              {elem.fieldType !== 'accordion'
                && checkProperty(elem, 'childElements')
                ? elem.childElements.map((childElm1) => checkFieldType(childElm1, props)
                )
                : (
                  <div className={elem.cssProperties.style}>
                    {findElement(elem, props)}
                  </div>
                )}
            </div>
          )
        )}
      </div>
    )));
  /* eslint-enable react/no-array-index-key -- need it temporarly */
};
